import { ICreateAssistenciaRegistroAtendimentoUseCase } from "../../../presentation/useCases/create/create_assistencia_registro_atendimento_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateAssistenciaRegistroAtendimentoUseCase
 */

export class CreateAssistenciaRegistroAtendimentoUseCase implements ICreateAssistenciaRegistroAtendimentoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createAssistenciaRegistroAtendimento(
    idAssistenciaTecnica: number,
    tipo: number,
    descricao: string,
    dataInicio: Date | null,
    dataTermino: Date | null,
    observacoes: string | null,
    responsavelConstrutora: number | null,
    responsavelCliente: string | null,
  ): Promise<void> {
    await this.repository.createAssistenciaRegistroAtendimento(
      idAssistenciaTecnica,
      tipo,
      descricao,
      dataInicio,
      dataTermino,
      observacoes,
      responsavelConstrutora,
      responsavelCliente,
    );
  }
}
